import { IGif } from '@giphy/js-types'
import React from 'react'
import ReactDOMServer from 'react-dom/server'
import GifDisplay, { getRenditionUrl } from './components/gif-display'
import { allGifs } from './components/grid'

// find the gif id from the img src
const srcReg = /giphy.com\/media\/(.*?)\//
const srcRegDynamicText = /token=(.*?)\.(.*?)\.(.*?)&/

export const getId = (data: string): string => {
    let match = srcReg.exec(data)
    if (match) {
        const [, id] = match
        return id
    }
    match = srcRegDynamicText.exec(data)
    if (match) {
        return match[3]
    }
    return ''
}
document.body.addEventListener('dragstart', (e) => {
    const { dataTransfer } = e
    if (dataTransfer) {
        const id = getId(dataTransfer.getData('text/html'))
        if (id) {
            dataTransfer.dropEffect = 'copy' // shows the appropriate animation
            dataTransfer.effectAllowed = 'copy'
            const gif = allGifs.find((gif: IGif) => id === gif.id)
            if (gif) {
                // rendered html that we'll insert
                const staticMarkup = ReactDOMServer.renderToStaticMarkup(<GifDisplay gif={gif} />)

                // for when markup doesn't work, we want the full size asset here
                const url = getRenditionUrl(gif)

                // following this: https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types
                // gmail will get text/html with attribution
                dataTransfer.setData('text/html', staticMarkup)
                // when dropping in the chrome ext, text/html sometimes worked
                // but failed if you drop right in the browser window, unless
                // we include the uri-list
                dataTransfer.setData('text/uri-list', url)
                dataTransfer.setData('text/plain', url)
            }
        }
    }
})
